export const STRAPI_URL = 'https://dortmund-strapi-dev.i-taros.net';

export const TEMPLATES_URL = 'https://apiqs.i-taros.net/templates/generate/';

export const TEMPLATE_SERVICE_SERVER_ID = 'dev';
export const TEMPLATE_SERVICE_CLIENT_ID = 'client_I8kw7_20240725110855011';
export const TEMPLATE_SERVICE_PASSWORD = 'strifeberserkers:A*x!~HZ5]V5PkdSx';
